import { ApiClient } from 'ApiClient';
import { Customer, MenuItem } from 'interfaces';

class CustomerService {
  public async getAll(): Promise<Customer[]> {
    return ApiClient.get<MenuItem[]>('customers');
  }

  public save({ id, data }: { id?: number; data: any }) {
    if (id) {
      return ApiClient.put(`customers/${id}`, data);
    }

    return ApiClient.post('customers', data);
  }

  public delete(id: number) {
    return ApiClient.delete(`customers/${id}`);
  }

  /**
   * Lightweight autocomplete for the manual booking dialog. Returns up
   * to 10 customers matching name, phone, or email.
   */
  public async search(q: string): Promise<Customer[]> {
    if (!q || q.trim().length < 2) return [];
    return ApiClient.get<Customer[]>('customers/search', { q: q.trim() });
  }
}

const singleton = new CustomerService();

export { singleton as CustomerService };
